document.addEventListener(
  'DOMContentLoaded',
  () => {
    document.querySelectorAll('.sec-HeroFullWidthImage_Video-icon').forEach(button => {
      button.addEventListener('click', () => {
        let video = ''
        if (button.classList[1] === 'sec-HeroFullWidthImage_Video-desktop') {
          video = button.parentNode.querySelector('video.sec-HeroFullWidthImage_Video-desktop')
          button.remove()

          document
            .querySelector('.sec-HeroFullWidthImage_Video-controls')
            .classList.remove('sec-HeroFullWidthImage_Video-controls')
        } else if (button.classList[1] === 'sec-HeroFullWidthImage_Video-mobile') {
          video = button.parentNode.querySelector('video.sec-HeroFullWidthImage_Video-mobile')
          button.remove()
        }
        video.play()
        video.setAttribute('controls', true)
      })
    })
  },
  false,
)
